import DOMPurify from "dompurify";

const normalise = (text) => (text || "").replace(/\s+/g, " ").trim().toLowerCase();

const stripIfEmpty = (node) => {
  const parent = node.parentElement;
  node.remove();
  if (parent && parent.tagName !== "BODY" && !parent.textContent.trim() && !parent.querySelector("img")) {
    parent.remove();
  }
};

// The upstream article HTML repeats the title as an <h1> and the hero image at the
// top of the body, which we already render in our own header. Drop those duplicates.
export const prepareArticleHtml = (html, { title, heroImageUrl } = {}) => {
  const clean = DOMPurify.sanitize(html || "");
  if (!clean) return "";

  const doc = new DOMParser().parseFromString(clean, "text/html");
  const body = doc.body;

  body.querySelectorAll("h1").forEach((h1) => {
    if (!title || normalise(h1.textContent) === normalise(title)) stripIfEmpty(h1);
  });

  if (heroImageUrl) {
    body.querySelectorAll("img").forEach((img) => {
      if (img.getAttribute("src") === heroImageUrl) stripIfEmpty(img);
    });
  }

  // House style: no em dashes in visible copy, including syndicated articles.
  body.querySelectorAll("*").forEach((el) => {
    el.childNodes.forEach((node) => {
      if (node.nodeType === 3 && /[\u2013\u2014]/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue
          .replace(/\s+[\u2013\u2014]\s+/g, ", ")
          .replace(/\u2014/g, ", ");
      }
    });
  });

  return body.innerHTML;
};
